module.exports = __webpack_public_path__ + "img/city (10).f9d7bfc7.png";